import { combineReducers } from "redux";
import { boxConstants, initialBoxState } from "../_constants";

function origamisById(state = [], action) {
  switch (action.type) {
    case boxConstants.LOAD_SUCCESS:
      return action.data.origamis.entities.origamis || state;
    case boxConstants.LOAD_PAGE:
      // The first page of a load replaces whatever a previous load left, so a
      // re-mount (hot reload, a user change) starts clean instead of stacking
      // every id a second time. Later pages merge in behind it.
      return action.data.first
        ? { ...action.data.origamis.entities.origamis }
        : { ...state, ...action.data.origamis.entities.origamis };
    case boxConstants.ADD_ORIGAMI:
      return action.origamis.byId || state;
    case boxConstants.ADD_LINK:
    case boxConstants.ADD_LINK_PENDING:
    case boxConstants.DELETE_LINK:
      return action.byId || state;
    case boxConstants.DELETE_OG_REQUEST:
      return action.data.byId || state;
    default:
      return state;
  }
}

function allOrigamis(state = [], action) {
  switch (action.type) {
    case boxConstants.LOAD_SUCCESS:
      return action.data.origamis.result || state;
    case boxConstants.LOAD_PAGE:
      // First page replaces (see origamisById); later pages append. The query
      // is newest-first and pages do not overlap, so append keeps the order a
      // full load produced.
      return action.data.first
        ? [...action.data.origamis.result]
        : [...state, ...action.data.origamis.result];
    case boxConstants.ADD_ORIGAMI:
      return action.origamis.allIds || state;
    case boxConstants.SHUFFLE:
      return action.result || state;
    case boxConstants.FLOAT_TAGGED:
    case boxConstants.SORT_CREATEDAT_DESC:
    case boxConstants.SORT_CREATEDAT_ASC:
    case boxConstants.SORT_THICKNESS_DESC:
    case boxConstants.SORT_THICKNESS_ASC:
    case boxConstants.SORT_WIDTH_DESC:
    case boxConstants.SORT_WIDTH_ASC:
      return action.result || state;
    case boxConstants.DELETE_OG_REQUEST:
      return action.data.allIds || state;
    default:
      return state;
  }
}

/*
function tagsById(state = [], action) {
  switch(action.type) {
    case boxConstants.LOAD_SUCCESS: 
      return action.data.origamis.entities.tags;
    default: 
      return state;
  }
}


function linksById(state = [], action) {
  switch(action.type) {
    case boxConstants.LOAD_SUCCESS: 
      return action.data.origamis.entities.links;
    default: 
      return state;
  }
}
*/

const origamis = combineReducers({
  byId: origamisById,
  allIds: allOrigamis,
});

function status(state = initialBoxState, action) {
  switch (action.type) {
    case boxConstants.LOADING:
      return { ...state, loading: true };
    case boxConstants.SELECT:
      return { ...state, selected: action.id };
    case boxConstants.LOAD_REQUEST:
      // Every load starts clean, so the first page of this one picks the
      // selection even if a previous load was interrupted mid-stream. Not
      // `loaded` until this load's own first page: box.jsx shows the
      // placeholder model only for a box that has finished loading empty.
      return {
        ...state,
        loading: true,
        loaded: false,
        streaming: false,
        expectedTotal: null,
      };
    case boxConstants.LOAD_SUCCESS:
      return {
        ...state,
        loaded: true,
        loading: false,
        selected: action.data.origamis.result[0],
      };
    case boxConstants.LOAD_PAGE:
      return {
        ...state,
        loaded: true,
        // Clearing this on the first page is the whole point: box.jsx gates
        // its render on it, so the first model can start the moment page one
        // arrives instead of after the final one.
        loading: false,
        streaming: true,
        // Only the first page of a load picks a selection. Later pages must
        // not snap the user back to the top if they have already started
        // paging through what is on screen -- but if the first page came back
        // empty (all deleted rows), the first page with items still picks.
        selected: action.data.first
          ? action.data.origamis.result[0] ?? null
          : state.selected ?? action.data.origamis.result[0] ?? null,
        // The cached box size, for the #N numbers while pages are arriving;
        // set once per load, on the first page that has items.
        expectedTotal:
          'expectedTotal' in action.data
            ? action.data.expectedTotal
            : state.expectedTotal,
      };
    case boxConstants.LOAD_COMPLETE:
      // Also clears `loading`, so a user with zero origamis (no page ever
      // arrives) is not left behind the spinner forever.
      return {
        ...state,
        loaded: true,
        loading: false,
        streaming: false,
        expectedTotal: null,
      };
    case boxConstants.LOAD_FAILURE:
      return { ...state, loading: false, loaded: false };
    case boxConstants.SHUFFLE:
    case boxConstants.FLOAT_TAGGED:
    case boxConstants.SORT_CREATEDAT_DESC:
    case boxConstants.SORT_CREATEDAT_ASC:
    case boxConstants.SORT_THICKNESS_DESC:
    case boxConstants.SORT_THICKNESS_ASC:
    case boxConstants.SORT_WIDTH_DESC:
    case boxConstants.SORT_WIDTH_ASC:
      return { ...state, loading: false, sort: action.type };
    case boxConstants.ADD_ORIGAMI:
      return { ...state, selected: action.id };
    case boxConstants.DELETE_OG_REQUEST:
      return { ...state, selected: action.data.nextId };
    default:
      return state;
  }
}

export const box = combineReducers({
  status: status,
  origamis: origamis,
  //links: linksById,
  //tags: tagsById
});
